import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-wrap":"wrap"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"display":"flex","margin-top":"1rem","justify-content":"center"} }
const _hoisted_4 = { style: {"justify-content":"center","display":"flex","flex-wrap":"wrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicPageList = _resolveComponent("PublicPageList")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    false
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[1] || (_cache[1] = _createElementVNode("h4", {
            class: "mainpage_title",
            style: {"margin-top":"1.5rem","margin-bottom":"1.5rem","font-weight":"700"}
          }, "タイムライン", -1)),
          _createElementVNode("div", _hoisted_1, [
            (!_ctx.mainPageDto || !_ctx.mainPageDto.followedList || !_ctx.mainPageDto.followedList.content)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 誰かをフォローしよう！ "))
              : (_openBlock(), _createBlock(_component_PublicPageList, {
                  key: 1,
                  list: _ctx.mainPageDto.followedList.content
                }, null, 8, ["list"]))
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/projects",
              class: "btn projectListButton btn-sm",
              style: {"margin-right":"0.5rem"}
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode(" 記事一覧へ ")
              ])),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Loading, {
        ref: "loading",
        enableOnScrollEnd: true,
        onOnscrollend: _ctx.onScrollEnd
      }, {
        default: _withCtx(() => [
          (_ctx.mainPageDto && _ctx.mainPageDto.updatedProjectList && _ctx.mainPageDto.updatedProjectList.content)
            ? (_openBlock(), _createBlock(_component_PublicPageList, {
                key: 0,
                list: _ctx.mainPageDto.updatedProjectList.content
              }, null, 8, ["list"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onOnscrollend"])
    ])
  ]))
}